var lazyList = require('ember-lazy-list')
var ItemViewMixin = require('./item-view-mixin')

module.exports = lazyList.LazyItemView.extend(ItemViewMixin)
